export {default} from './ChangePasswordForm';



// WEBPACK FOOTER //
// ./src/containers/ChangePasswordForm/index.ts